import type { LucideIcon } from "lucide-react"
import {
  Wifi, Tv, Car, CookingPot, Briefcase, Waves, Building,
  Flower, Gamepad2, CameraOff, WashingMachine, Heater,
  Cigarette, KeyRound, Cross, FireExtinguisher, Droplets,
  AlarmSmoke, AirVent, Refrigerator, Flower2, Rose, WavesLadder,
} from "lucide-react"

// ── Types ─────────────────────────────────────────────────────────────────────

export type Amenity = {
  title: string
  icon: LucideIcon
}

export type AmenitySection = {
  title: string
  items: Amenity[]
}

// ── Individual amenities ──────────────────────────────────────────────────────

export const WIFI               : Amenity = { title: "Wifi",                                  icon: Wifi }
export const TV                 : Amenity = { title: "TV",                                    icon: Tv }
export const FREE_PARKING       : Amenity = { title: "Free parking on premises",              icon: Car }
export const KITCHEN            : Amenity = { title: "Kitchen",                               icon: CookingPot }
export const DEDICATED_WORKSPACE: Amenity = { title: "Dedicated workspace",                   icon: Briefcase }
export const POOL               : Amenity = { title: "Pool",                                  icon: WavesLadder }
export const LIFT               : Amenity = { title: "Lift",                                  icon: Building }
export const FRIDGE             : Amenity = { title: "Fridge",                                icon: Refrigerator }
export const AIR_CONDITIONING   : Amenity = { title: "Air conditioning",                      icon: AirVent }
export const FIRE_EXTINGUISHER  : Amenity = { title: "Fire extinguisher",                     icon: FireExtinguisher }
export const FIRST_AID_KIT      : Amenity = { title: "First aid kit",                         icon: Cross }
export const BACK_GARDEN        : Amenity = { title: "Back garden",                           icon: Rose }
export const PRIVATE_HOT_TUB    : Amenity = { title: "Private hot tub",                       icon: Waves }
export const SMOKING_ALLOWED    : Amenity = { title: "Smoking allowed",                       icon: Cigarette }
export const SELF_CHECK_IN      : Amenity = { title: "Self check-in (Lockbox)",               icon: KeyRound }
export const COURTYARD_VIEW     : Amenity = { title: "Courtyard view",                        icon: Flower }
export const GARDEN_VIEW        : Amenity = { title: "Garden view",                           icon: Flower2 }
export const CITY_VIEW          : Amenity = { title: "City skyline view",                     icon: Building }
export const EXERCISE_EQUIPMENT : Amenity = { title: "Exercise equipment",                    icon: Briefcase }
export const POOL_TABLE         : Amenity = { title: "Pool table",                            icon: Gamepad2 }
export const CINEMA             : Amenity = { title: "Cinema",                                icon: Tv }
export const BOARD_GAMES        : Amenity = { title: "Board games",                           icon: Briefcase }
export const WASHING_MACHINE    : Amenity = { title: "Washing machine",                       icon: WashingMachine }
export const HEATING            : Amenity = { title: "Heating",                               icon: Heater }
export const HOT_WATER          : Amenity = { title: "Hot water",                             icon: Droplets }
export const SMOKE_ALARM        : Amenity = { title: "Smoke alarm",                           icon: AlarmSmoke }
export const CO_ALARM           : Amenity = { title: "Carbon monoxide alarm",                 icon: AlarmSmoke }
export const SECURITY_CAMERAS   : Amenity = { title: "Exterior security cameras",             icon: CameraOff }

// ── All sections — used in the "Show all amenities" dialog ────────────────────
// Every possible amenity appears here. Ones a room doesn't have show as absent.

export const ALL_SECTIONS: AmenitySection[] = [
  {
    title: "Scenic views",
    items: [COURTYARD_VIEW, GARDEN_VIEW, CITY_VIEW, ],
  },
  {
    title: "Entertainment",
    items: [TV, CINEMA, POOL_TABLE, EXERCISE_EQUIPMENT],
  },
  {
    title: "Family",
    items: [BOARD_GAMES],
  },
  {
    title: "Heating and cooling",
    items: [AIR_CONDITIONING, HEATING],
  },
  {
    title: "Home safety",
    items: [FIRE_EXTINGUISHER, FIRST_AID_KIT, SMOKE_ALARM, CO_ALARM],
  },
  {
    title: "Internet and office",
    items: [WIFI, DEDICATED_WORKSPACE],
  },
  {
    title: "Kitchen and dining",
    items: [KITCHEN, FRIDGE],
  },
  {
    title: "Bathroom",
    items: [HOT_WATER, WASHING_MACHINE],
  },
  {
    title: "Outdoor",
    items: [BACK_GARDEN, POOL],
  },
  {
    title: "Parking and facilities",
    items: [FREE_PARKING, LIFT, PRIVATE_HOT_TUB],
  },
  {
    title: "Services",
    items: [SMOKING_ALLOWED, SELF_CHECK_IN],
  },
  {
    title: "Security",
    items: [SECURITY_CAMERAS],
  },
]
